import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@cuorum/ui/fonts.css';
import '@cuorum/ui/styles.css';
import './app/app.css';
import { App } from './app/App.tsx';
import { createApi } from './lib/api.ts';
import { createAiApi } from './lib/aiApi.ts';
import { createSessionApi } from './lib/session.ts';
import { DEMO_ACCOUNT } from './features/create/draft.ts';

const apiUrl = import.meta.env.VITE_API_URL;
const root = document.getElementById('root');
if (!root) throw new Error('falta #root en index.html');

createRoot(root).render(
  <StrictMode>
    <App api={createApi(apiUrl)} ai={createAiApi(apiUrl, DEMO_ACCOUNT.id)} session={apiUrl ? createSessionApi(apiUrl) : null} />
  </StrictMode>,
);
